module.exports = __webpack_public_path__ + "img/chexiao.2ff0cde8.png";